import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { CommonValidationComponent } from './validation.component';
import { CommonMinlengthValidatorModule } from '../../../validators/minlength/minlength.module';
import { CommonMaxlengthValidatorModule } from '../../../validators/maxlength/maxlength.module';
import { CommonRequiredValidatorModule } from '../../../validators/required/required.module';
import { CommonPatternValidatorModule } from '../../../validators/pattern/pattern.module';
import { CommonEmailValidatorModule } from '../../../validators/email/email.module';
import { CommonMatchValidatorModule } from '../../../validators/match/match.module';
import { CommonGroupRequiredModule } from '../../../validators/group_required/group_required.module';
import { CommonNumberInSafeRangeValidatorModule } from '../../../validators/number_In_safe_range/number_In_safe_range.module';
import { CommonMinValidatorModule } from '../../../validators/min/min.module';
import { CommonMaxValidatorModule } from '../../../validators/max/max.module';
import { CommonPasswordValidatorModule } from '../../../validators/password/common.password_validator.module';

@NgModule({
    imports: [
        CommonModule,
        CommonMinlengthValidatorModule,
        CommonMaxlengthValidatorModule,
        CommonRequiredValidatorModule,
        CommonPatternValidatorModule,
        CommonEmailValidatorModule,
        CommonMatchValidatorModule,
        CommonGroupRequiredModule,
        CommonNumberInSafeRangeValidatorModule,
        CommonMinValidatorModule,
        CommonMaxValidatorModule,
        CommonPasswordValidatorModule,
    ],
    declarations: [
        CommonValidationComponent,
    ],
    exports: [
        CommonValidationComponent,
        CommonMinlengthValidatorModule,
        CommonMaxlengthValidatorModule,
        CommonRequiredValidatorModule,
        CommonPatternValidatorModule,
        CommonEmailValidatorModule,
        CommonMatchValidatorModule,
        CommonGroupRequiredModule,
        CommonNumberInSafeRangeValidatorModule,
        CommonMinValidatorModule,
        CommonMaxValidatorModule,
        CommonPasswordValidatorModule,
        CommonModule,
        FormsModule,
    ]
})
export class CommonValidationModule {}
